"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var atoms_1 = require("../../atoms");
var Collapse_1 = require("../../icons/Collapse");
var Expand_1 = require("../../icons/Expand");
var styles_1 = require("./styles");
var MultiCard = function (_a) {
    var children = _a.children, numberOfElements = _a.numberOfElements, _b = _a.showNumberOfElements, showNumberOfElements = _b === void 0 ? true : _b, _c = _a.mostRecentValueAsFirst, mostRecentValueAsFirst = _c === void 0 ? false : _c;
    var _d = (0, react_1.useState)(true), open = _d[0], setOpen = _d[1];
    var classname = (0, styles_1.useStyles)({ showNumberOfElements: showNumberOfElements, mostRecentValueAsFirst: mostRecentValueAsFirst });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classname.headerContainer }, { children: [(0, jsx_runtime_1.jsx)(atoms_1.Legend, __assign({ style: {
                            textTransform: 'capitalize',
                            visibility: showNumberOfElements ? 'visible' : 'hidden'
                        } }, { children: "".concat(numberOfElements, " Items") })), (0, jsx_runtime_1.jsx)(atoms_1.Button, __assign({ id: "expandOrCloseAll", variant: "text", onClick: function () { return setOpen(!open); }, startIcon: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ width: 23, height: 23, viewBox: "-10 -3 25 25", color: "#5d89ad" }, { children: open ? (0, jsx_runtime_1.jsx)(Collapse_1.Collapse, {}) : (0, jsx_runtime_1.jsx)(Expand_1.Expand, {}) })) }, { children: open ? 'COLLAPSE ALL' : 'EXPAND ALL' }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classname.cardContainer }, { children: react_1.default.Children.map(children, function (child) {
                    if (react_1.default.isValidElement(child)) {
                        // @ts-ignore
                        return react_1.default.cloneElement(child, { handleByParent: true, openByParent: open });
                    }
                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
                }) }))] }));
};
exports.MultiCard = MultiCard;
